/**
 * Paths whose body copy exists in every locale shipped by the site.
 *
 * Only these get a language-prefixed URL (/es/about, /ar/faq, …). Pages without
 * translations keep a single English URL: labelling an English page as another
 * language would be a false hreflang signal.
 *
 * Kept dependency-free so build tooling can import it without pulling in i18n.
 */
export const TRANSLATED_PATHS: string[] = [
  '/',
  '/products',
  '/infrared-heaters',
  '/portable-heaters',
  '/gas-heaters',
  '/about',
  '/contact',
  '/faq',
  '/technology',
  '/installations',
  '/installation-guide',
  '/warranty-policy',
  '/privacy-policy',
  '/terms-of-service',
];
